__turbopack_context__.v({
  "content_row_description": "ContentRowTitleDescription-module-scss-module__V4XHHG__content_row_description",
  "content_row_title": "ContentRowTitleDescription-module-scss-module__V4XHHG__content_row_title",
  "content_row_title__logo": "ContentRowTitleDescription-module-scss-module__V4XHHG__content_row_title__logo",
  "content_row_title__logo__wrapper": "ContentRowTitleDescription-module-scss-module__V4XHHG__content_row_title__logo__wrapper",
  "content_row_title_description": "ContentRowTitleDescription-module-scss-module__V4XHHG__content_row_title_description",
});
